<template>
  <div class="promote flex flex-y relative" v-bind:style="{ paddingTop }">
    <div class="width-full text-0 absolute" style="top: 0px">
      <img
        class="width-full"
        ref="custom"
        src="@/assets/images/promote/user/bg.png?time=123456"
        alt="邀请车主奖13元现金"
        @load="handleContent"
      />
      <button class="absolute text-14 text-white" @click="handleRule">活动规则</button>
    </div>
    <div class="content text-14 relative" style="z-index: 1" v-bind:style="{ paddingBottom }">
      <div class="invite">
        <div>
          <div v-if="!list.length" class="empty flex flex-y flex-center">
            <div class="text-500 margin-bottom-16" style="color: #FA7600">“您已经领取过啦，快去乘车吧”</div>
            <button @click="handleDownload" class="flex text-500 text-12 text-white flex-center">
              <span>去乘车</span>
              <img class="margin-left-4" src="@/assets/images/promote/custom/arrow-right.png" alt="" />
            </button>
          </div>
          <div
            class="coupon flex flex-center margin-bottom-10"
            v-for="item in list"
            :key="item.id"
          >
            <div class="coupon-left flex-1 flex flex-center text-500 text-12">
              <div><span>{{ item.reductionAmount }}</span>元</div>
            </div>
            <div class="coupon-middle">
              <div></div>
            </div>
            <div
              class="coupon-right flex align-center justify-between padding-lr-8"
            >
              <div style="width: calc(100% - 62px)">
                <div class="text-500 width-full text-line-1" style="color: #000">{{ item.couponName }}</div>
                <div class="text-grey9 width-full text-line-1 margin-top-2">
                  限顺风车新客；满{{ item.fullMinimumAmount }}可用
                </div>
                <div class="text-grey9 width-full margin-top-10 text-line-1">
                  有效期至{{ item.couponEndTime }}
                </div>
              </div>
              <button @click="handleDownload">立即使用</button>
            </div>
          </div>
          <div class="text-center margin-top-4 text-white" style="font-size: 11px">活动权益已发放至{{ $route.query.mobile }}账户</div>
        </div>
      </div>
    </div>
    <div class="width-full text-0 btn-bottom" style="z-index: 1">
      <img @click="handleDownload" class="width-full" src="@/assets/images/promote/user/btn.png" alt="我要邀请" />
    </div>
  </div>
</template>

<script>
import { handleDownload } from '@/utils/handle_app'
import { getNewUserCouponInfo } from '@/api/modules/promote'

export default {
  data () {
    return {
      paddingTop: '59.9315vh',
      paddingBottom: '126px',
      showAll: false,
      list: [
        // { id: '1', title: '顺风车首单立减20元', amount: 20, desc: '限顺风车新客；满35可用', time: '2021-10-30 23:59:59' },
        // { id: '2', title: '顺风车首单立减20元', amount: 20, desc: '限顺风车新客；满35可用', time: '2021-10-30 23:59:59' },
        // { id: '3', title: '顺风车首单立减20元', amount: 20, desc: '限顺风车新客；满35可用', time: '2021-10-30 23:59:59' }
      ],
      params: {
        activityId: 212570000003
      }
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      const { activityId } = this.params

      getNewUserCouponInfo(activityId).then(data => {
        this.list = data.couponList
      })
    },
    handleRule () {
      this.$router.push('/agreement/detail/21165000000004')
    },
    handleDownload () {
      handleDownload('user')
    },
    handleContent () {
      const height = this.$refs.custom.clientHeight

      this.paddingTop = Math.floor(height * 0.585 * 10000) / 10000 + 'px'
      this.paddingBottom = document.querySelector('.promote .btn-bottom').clientHeight + 40 + 'px'
    },
    resizing () {
      this.ticking = false
      this.handleContent()
    },
    onResize () {
      if (!this.ticking) {
        window.requestAnimationFrame(this.resizing)
        this.ticking = true
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.onResize, false)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize, false)
  }
}
</script>

<style lang="scss" scoped>
.promote {
  min-height: 100vh;
  overflow: hidden;
  background-color: #ff8f0a;

  button {
    padding: 0px;
    margin: 0px;
    outline: none;
    border: none;
    text-align: center;
    background-color: transparent;
  }

  .text-0 {
    font-size: 0px;
  }

  .text-500 {
    font-weight: 500;
  }

  .text-17 {
    font-size: 17px;
  }

  .text-11 {
    font-size: 11px;
    color: #ffaa93;
  }

  .text-700 {
    font-weight: 700;
    font-size: 25px;
    font-family: DIN Alternate, DIN Alternate-Bold;
  }

  img + button.absolute {
    width: 85px;
    height: 30px;
    right: 0px;
    top: 4.2465%;
    background-color: rgba(255, 255, 255, 0.22);
    border-radius: 15px 0px 0px 15px;
  }

  .content {
    padding: 10px 16px 40px;

    .invite {
      width: calc(100% + 6px);
      margin: 0px -3px;
      padding: 3px;
      position: relative;
      border-radius: 13px;
      overflow: hidden;

      &::before {
        content: '';
        width: 100%;
        height: 105px;
        display: block;
        background: linear-gradient(0deg, #ffab46 0%, #ffdfb1 100%);
        position: absolute;
        top: 0px;
        left: 0px;
      }

      & > div {
        position: relative;
        padding: 24px 12px 0px;
        border-radius: 13px;
        overflow: hidden;
        z-index: 2;

        & > div {
          position: relative;
          z-index: 2;
        }

        &::before {
          content: '';
          width: 100%;
          height: 99px;
          display: block;
          background: linear-gradient(180deg,#ff8502 0%, #ffab46 100%);
          position: absolute;
          top: 0px;
          left: 0px;
        }
      }
    }
  }

  .empty {
    height: 123px;
    margin-bottom: 10px;
    border-radius: 8px;
    background-color: #FFF3E4;

    button {
      width: 135px;
      height: 28px;
      background: linear-gradient(180deg,#ececeb 0%, #fafafa 0%, #ff8808 0%, #ff4800 100%);
      border-radius: 14px;

      img {
        width: 6px;
      }
    }
  }

  .coupon {
    height: 90px;
    border-radius: 8px;
    overflow: hidden;
  }

  .coupon-left {
    height: 100%;
    margin-right: -1px;
    color: #FF4800;

    span {
      font-size: 26px;
    }
  }

  .coupon-left,
  .coupon-right {
    height: 100%;
    background-color: #FFF3E4
  }

  .coupon-right {
    width: 74.5%;
    margin-left: -1px;

    button {
      width: 62px;
      line-height: 26px;
      text-align: center;
      font-size: 11px;
      color: #fff;
      background: linear-gradient(180deg,#ececeb 0%, #fafafa 0%, #ff8808 0%, #ff4800 100%);
      border-radius: 23px;
    }

    .text-grey9 {
      color: #999;
      font-size: 10px;
    }
  }

  .coupon-middle {
    width: 12px;
    height: 100%;
    position: relative;
    overflow: hidden;
  }
  .coupon-middle div { /* 中间虚线 */
    height: calc(100% - 6px);
    width: 12px;
    top: 3px;
    background-color: #FFF3E4;

    &, &:before {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;
    }

    &:before {
      content: '';
      display: block;
      height: 100%;
      border-left: 1px solid #FFD5A1;
      z-index: 2;
    }
  }
  .coupon-middle:before, .coupon-middle:after {
      content: '';
      border: 6px solid #FFF3E4;
      position: absolute;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      left: 50%;
      transform: translateX(-50%);
  }
  .coupon-middle:before {
      top: -9px;
  }
  .coupon-middle:after {
      bottom: -9px;
  }

  .btn-bottom {
    position: fixed;
    max-width: 750px;
    bottom: 0px;
    padding: 8px 18px 28px;
    background-color: #FF8B0C;
    box-shadow: 0px -8px 27px 0px #ff7816;
    z-index: 2;
  }
}
</style>
